import { render } from "./trtcCalling.vue?vue&type=template&id=6e304a66&scoped=true"
import script from "./trtcCalling.vue?vue&type=script&lang=js"
export * from "./trtcCalling.vue?vue&type=script&lang=js"

import "./trtcCalling.vue?vue&type=style&index=0&id=6e304a66&lang=scss&scoped=true"
import "./trtcCalling.vue?vue&type=style&index=1&id=6e304a66&lang=scss"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e304a66"]])

export default __exports__